<script lang="ts" setup>
import {FetchError} from "ofetch";

const {title, error} = defineProps<{
  title?: string;
  error?: FetchError;
}>();

useHead({
  title: title ?? error?.statusMessage,
});

const spineTitleState = useState("spineTitle");
spineTitleState.value = "Page not found";
</script>

<template>
  <div
    class="content-grid bg-black has-logo-overlay-right min-h-full text-white">
    <div class="min-h-full flex flex-col justify-center items-center gap-4">
      <span class="text-6xl text-center">Page not found</span>
      <span class="text-3xl text-center text-neutral-700">
        it seems to be lost in darkness.
      </span>
      <NuxtLinkLocale to="/" class="font-sans link-underline"
        >Go to homepage</NuxtLinkLocale
      >
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
